export default __webpack_public_path__ + "static/media/17.123c407c.jpg";